import { createContext } from 'react'

export type EndOfArticleContextType = boolean

const EndOfArticleContext = createContext<EndOfArticleContextType | undefined>(
  undefined
)

export default EndOfArticleContext
